import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setPackToEdit} from 'actions/index.js';
import {newPack} from 'packs/packs.js';
import PackContent from "components/packs/PackContent.js";
import {
    setSampleDragging,
    setPresetDragging,
    setDraggingPackWindow,
    setCreatingNewPack
       } from 'actions/index.js';
import {connect} from 'react-redux';

const NewPackWindow = ({
    creatingNewPack,
    position,
    sequencerEngine,
    sampleDragging,
    setSampleDragging,
    setPresetDragging,
    setCreatingNewPack,
    setDraggingPackWindow,
    setPackToEdit,
    presetDragging,
    selectedPreset,
    setSave,
    json={title:"", samples:[], description:"", presets: []}
}) => { 
    const [edited, setEdited] = useState(false);
    const [samples, setSamples] = useState(json.samples || []);
    const [presets, setPresets] = useState(json.presets || []);
    const [name, setName] = useState(json.title);
    const [description, setDescription] = useState(json.description);
    const [packHash, setPackHash] = useState(json.packHash);

    useEffect(() => {
        if (creatingNewPack && creatingNewPack.name) {
            // then its a sample that we should add
            setSamples([creatingNewPack]);
        } else if (creatingNewPack && creatingNewPack.title) {
            setPresets([creatingNewPack]);
        }
    }, [creatingNewPack]);

    const ref = useRef(undefined);
    const onMouseDown = useCallback((e) => {
        let rect = ref.current.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        setDraggingPackWindow({x,y});
    }, []);

    useEffect(() => {
        if (!setSave) {
            return;
        }
        setSave({fn: (preset) => {
            if (presets.includes(preset)) {
                return;
            }
            setPresets([... presets, preset]);
            onClickSave();
        }});
    }, [setSave, samples, presets, setPresets, packHash, setPackHash]);

    const onClickSave = useCallback((e) => {
        newPack(
            name,
            description,
            samples.map(s => s.getId()),
            presets.map(x => x.contentHash),
            packHash)
            .then(s => {
                console.log('setting pack hash=', s);
                // setPackHash(s);
            });
        setCreatingNewPack(false);
        setPackToEdit(undefined);
        setEdited(false);
    }, [name, description, samples, presets, json, setEdited, packHash, setPackHash]);

    const onDrop = useCallback((e) => {
        e.stopPropagation();

        if (sampleDragging) {
            setSamples([... samples, sampleDragging]);
            setSampleDragging(undefined);
            setEdited(true);
        } else if (presetDragging) {
            setPresets([... presets, presetDragging]);
            setPresetDragging(undefined);
            setEdited(true);
        }
    }, [
        sampleDragging,
        setEdited,
        setSamples,
        samples,
        presetDragging,
        setPresets,
        presets
    ]);

    const onDelete = useCallback((content) => {
        if (samples.includes(content)) {
            setSamples(samples.filter(x => x !== content));
            setEdited(true);
        } else if (presets.includes(content)) {
            setPresets(presets.filter(x => x !== content));
            setEdited(true);
        }
    }, [samples, setSamples, presets, setPresets, setEdited]);

    let style = {
        left: position.x,
        top: position.y
    };

    console.log(sequencerEngine);
    let content = [...samples, ...presets];
    return (
        <div
          style={style}
          onDrop={onDrop}
          ref={ref}
          onMouseDown={onMouseDown}
          onMouseUp={() => setDraggingPackWindow(undefined)}
          className="pack-window no-select">
          <div className="floppy-top">
            <input
              placeholder="Type name here"
              className="pack-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}/>
          </div>
          <div onClick={() => {
              setCreatingNewPack(false);
              setPackToEdit(undefined);
          }} className="delete-btn">x</div>
          {content.length === 0 ? 
          <div className="drop-here">
            Drop sounds and presets here.
          </div> : 
           <div className="contents">
             {samples.map(
                 sample =>
                     <PackContent key={sample.getId()} onDelete={onDelete} sample={sample}/>)}
             {presets.map(
                 preset =>
                 <PackContent
                   isSelected={preset && preset.contentHash === selectedPreset}
                   sequencerEngine={sequencerEngine} key={preset.contentHash} onDelete={onDelete} preset={preset}/>)}
           </div>}
          <textarea
            onMouseDown={(e) => e.stopPropagation()}
            spellcheck="false"
            className="pack-description"
            onChange={(e) => setDescription(e.target.value)}
            type="textarea" value={description}/>
          <div
            onClick={onClickSave}
            className={edited ? "save-button" : "save-button disabled"}>
            Save Curated List Changes
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      position: state.packs.windowPosition,
      sampleDragging: state.selector.sampleDragging,
      presetDragging: state.presets.presetDragging,
      creatingNewPack: state.packs.creatingNewPack,
      selectedPreset: props.track && props.track.preset && props.track.preset.contentHash
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setDraggingPackWindow: (x) => dispatch(setDraggingPackWindow(x)),
      setCreatingNewPack: (x) => dispatch(setCreatingNewPack(x)),
      setSampleDragging: (x) => dispatch(setSampleDragging(x)),
      setPresetDragging: (x) => dispatch(setPresetDragging(x)),
      setPackToEdit: x => dispatch(setPackToEdit(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPackWindow);
